<template>
    <Modal :is_show="is_show" @click-bg="close()" class="add-creator-modal add-title-modal edit-program-set-pop">
        <header class="edit_program_header">About Application <i @click="close()"><svg-icon name="close" /></i>
        </header>
        <Scrollbar class="edit-scroll-list" :show_bar="true">
            <div class="edit_program_body">

                <div class="box question-templeat">

                    <div class="edit-item" :key="key_ref">
                        <!-- title -->
                        <div class="line">
                            <div class="name">{{data[ind.application_title.i].question[ind.application_title.ii].name}}<div class="red">*</div></div>
                        </div>
                        <Field :type="data[ind.application_title.i].question[ind.application_title.ii].client_view.client_type" :k="data[ind.application_title.i].question[ind.application_title.ii].label" :placeholder="data[ind.application_title.i].question[ind.application_title.ii].client_view.plac"
                            @update="update" :had_value="data[ind.application_title.i].question[ind.application_title.ii].client_view.val"/>

                        <!-- summary -->
                        <div class="line">
                            <div class="name">{{data[ind.summary.i].question[ind.summary.ii].name}}</div>
                            <div class="handle_req" >
                                <Switch :checked="data[ind.summary.i].is_switch" @click.native="data[ind.summary.i].is_switch = data[ind.summary.i].is_switch ? false : true" />
                            </div>
                        </div>
                        <Field v-if="data[ind.summary.i].is_switch" :type="data[ind.summary.i].question[ind.summary.ii].client_view.client_type" :k="data[ind.summary.i].question[ind.summary.ii].label" :placeholder="data[ind.summary.i].question[ind.summary.ii].client_view.plac"
                            @update="update" :had_value="data[ind.summary.i].question[ind.summary.ii].client_view.val"/>
                    </div>
                </div>
            </div>
        </Scrollbar>

        <!-- save -->
        <div class="save-btn-box">
            <el-button type="primary" size="large" class="save-btn" :disabled="!temp_data.application_title" @click="save">Save</el-button>
        </div>
    </Modal>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import Modal from '@/components/ui/Modal.vue';
import Field from '@/components/ui/Field.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Switch from '@/components/ui/Switch.vue';
import { getIndex } from '@/utils/ProgramsData.js';
import { ElButton } from 'element-plus';

const props = defineProps({
    is_show: { type: Boolean, default: true },
    data: { type: Array, default: () => [] },
    is_edit: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'save']);

const temp_data = reactive({
    application_title: '',
    summary: '',
    switch: false,
});
const ind = reactive({
    application_title: { ii: 0, i: 0 },
    summary: { ii: 0, i: 0 },
});
const key_ref = ref(0);

const update = (obj) => {
    Object.keys(temp_data).forEach(key => {
        if (key === obj.key) temp_data[key] = obj.val;
    });
};

const setDate = () => {
    props.data[ind.application_title.i].question[ind.application_title.ii].client_view.val = temp_data.application_title;
    props.data[ind.summary.i].question[ind.summary.ii].client_view.val = props.data[ind.summary.i].is_switch ? temp_data.summary : '';
    props.data[ind.summary.i].question[ind.summary.ii].is_switch = props.data[ind.summary.i].is_switch;
    props.data[ind.summary.i].question[ind.summary.ii].show = props.data[ind.summary.i].is_switch;
};

const save = () => {
    setDate();
    emit('save', { data: props.data, type: 'title' });
};

const close = () => {
    props.data[ind.summary.i].question[ind.summary.ii].is_switch = temp_data.switch;
    emit('close');
};

onMounted(() => {
    Object.assign(ind, {
        application_title: getIndex(props.data, 'title', 'application_title'),
        summary: getIndex(props.data, 'summary', 'summary'),
    });
    temp_data.application_title = props.data[ind.application_title.i].question[ind.application_title.ii].client_view.val;
    temp_data.summary = props.data[ind.summary.i].question[ind.summary.ii].client_view.val;
    temp_data.switch = props.data[ind.summary.i].is_switch;
    key_ref.value += 1;
});
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.add-title-modal{
    .edit-item{
        margin-top:8px !important;
    }

    .edit-scroll-list{
        overflow: unset !important;
    }
}
</style>
